import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=67f9583a&"
import script from "./OrderDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=67f9583a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports